var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-grid',{attrs:{"column-num":3,"icon-size":"100px"}},[_c('van-grid-item',{attrs:{"icon":_vm.lxdyandirod,"text":"联想打印安卓"}}),_c('van-grid-item',{attrs:{"icon":_vm.lxdyios,"text":"联想打印IOS"}}),_c('van-grid-item',{attrs:{"icon":_vm.wxmini,"text":"微信小程序"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }